// extracted by mini-css-extract-plugin
export var columnItem = "_dm-3";
export var columnItemDraggable = "_dm-4";
export var dragHandle = "_dm-0";
export var dragHandleHovered = "_dm-1";
export var dropdown = "_dm-5";
export var dropdownContent = "_dm-7";
export var dropdownInner = "_dm-6";
export var filterDropdownHeader = "_dm-8";
export var icon = "_dm-2";
export var sectionDivider = "_dm-9";